var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulbBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 48,
    viewBox: "0 0 52 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 4.22219V2",
    stroke: "#01342C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.332 8.66653L45.5542 6.44434",
    stroke: "#01342C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4453 6.44434L16.6675 8.66653",
    stroke: "#01342C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0891 43.086C19.1529 44.0454 14.1699 42.0715 10.1706 38.6931C6.18982 35.3254 3.18453 30.5247 4.01429 26.8211C4.84404 23.1176 9.50884 20.5114 13.7374 18.3186C17.9474 16.1152 21.7212 14.3253 24.6509 15.2801C27.5807 16.2349 29.6479 19.9237 30.8716 23.577C32.1241 27.2231 32.4856 30.8302 31.2176 34.5659C29.9496 38.3015 27.0335 42.155 23.0891 43.086Z",
    fill: "#E7CCA5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9996 10.8887C23.8632 10.8887 18.8887 15.8632 18.8887 21.9996C18.8887 25.0247 20.0976 27.7673 22.0587 29.7711C22.8225 30.5515 23.4504 31.4802 23.6647 32.551L24.8404 38.427C25.2561 40.5043 27.0801 41.9994 29.1985 41.9994H30.8007C32.9191 41.9994 34.7431 40.5043 35.1589 38.427L36.3347 32.551C36.5489 31.4802 37.1766 30.5515 37.9406 29.7711C39.9017 27.7673 41.1106 25.0247 41.1106 21.9996C41.1106 15.8632 36.136 10.8887 29.9996 10.8887Z",
    stroke: "#01342C",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7773 21.9998H49.9995",
    stroke: "#01342C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2222 21.9998H10",
    stroke: "#01342C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5547 33.1106H34.4435",
    stroke: "#01342C",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulbBlob);
export default __webpack_public_path__ + "static/media/bulb-blob.e560166e0ff27e69359811dc9166445b.svg";
export { ForwardRef as ReactComponent };